export default __webpack_public_path__ + "static/media/younion.01ad8dc8.jpeg";